import { DeliveriesModel } from '@w3lcome/types';

import BaseRequest from './BaseRequest';

const api = new BaseRequest<DeliveriesModel>('/ipad/deliveries');

export default api;
